import { Injectable } from '@angular/core';
import { Observable, Observer, throwError, BehaviorSubject } from 'rxjs';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { FileData } from '../../models/';
import { IResult, UAParser } from 'ua-parser-js';
import {
  IPostTunningRequest,
  IResultTest,
  IUAParserInfo,
} from '../../api/apiTunning/apiTunning.models';
import { EnvironmentService } from '../enviroment/environment.service';
declare const window: any;

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  defaultDevicesList: any = null;
  devicesList: any  = null;
  deviceInfo: IUAParserInfo | null = null;
  constructor(
    private readonly sanitizer: DomSanitizer,
    private readonly envConf: EnvironmentService,
  ) {}

  // Safari on Mac or Mobile
  isSafariOrUiwebview() {
    const result = /(iPhone|iPod|iPad).*AppleWebKit\//i.test(window.navigator.userAgent);
    console.log('**********isSafariOrUiwebview***********', result);
    return result;
  }

  // Safari on Mac Only
  isSafariMac() {
    return /^((?!chrome|android).)*safari\//i.test(window.navigator.userAgent);
  }

  // Safari in webwiew on Mobile
  isUiwebview() {
    const result = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)\//i.test(
      window.navigator.userAgent,
    );
    console.log('**********isUiwebview***********', result);
    return result;
  }

  /**
   * Comprueba si es un dispositivo móvil
   */
  isMobile() {
    // detect user agent
    const mobile =
      /iphone|ipod|webos|android|blackberry|mini|iemobile|opera mini|windows\sce|palm\//i.test(
        window.navigator.userAgent.toLowerCase(),
      );
    let result = false;

    if (mobile) {
      result = true;
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.search('android') > -1 && userAgent.search('mobile') > -1) {
        // android mobile
        result = true;
      } else if (userAgent.search('android') > -1 && !(userAgent.search('mobile') > -1)) {
        // android tablet
        result = false;
      }
    }
    return result;
  }

  isIOs(): boolean {
    return /iPhone|iPad|iPod|Mac/i.test(navigator.userAgent);
  }

  isAndroid(): boolean {
    return /Android/i.test(navigator.userAgent);
  }

  isWindows(): boolean {
    return /Windows/i.test(navigator.userAgent);
  }

  isIPhone(): boolean {
    if (/iPhone/.test(navigator.userAgent)) {
      return true;
    } else {
      return !this.isIpadOS();
    }
  }

  isIpadOS(): boolean {
    return navigator?.maxTouchPoints > 2 && /Mac/.test(navigator.userAgent);
  }  
  
  isMacBook(): boolean {
    return !this.isIPhone() && !this.isIpadOS();
  }

  isDesktop(): boolean {
    return !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent,
    );
  }

  /**
   * Checks if the device is a tablet
   * @returns boolean indicating if the device is a tablet
   */
  isTablet(): boolean {
    // Early desktop check
    if (this.isDesktop()) return false;

    // Modern iPad detection (iPadOS 13+ reports as desktop)
    if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
      return true;
    }

    // Traditional iPad detection
    if (/iPad/i.test(navigator.userAgent)) return true;

    // Android tablet detection
    if (/Android/i.test(navigator.userAgent) && !/Mobile/i.test(navigator.userAgent)) {
      return true;
    }

    // Touch-capable device with tablet-like dimensions
    if (navigator.maxTouchPoints > 1) {
      const { width, height } = window.screen;
      const minDim = Math.min(width, height);
      const maxDim = Math.max(width, height);
      return minDim >= 768 && maxDim / minDim <= 1.5;
    }

    return false;
  }

  /**
   * Match device with UA-Parser
   * @returns
   */
  isIOsMobilityUAPArser() {
    return this.isIphoneUAPArser() || this.isIpadUAPArser();
  }
  /**
   * Match device with UA-Parser
   * @returns
   */
  isIOsMobilityWebViewUAPArser() {
    const result =
      (this.isIphoneUAPArser() || this.isIpadUAPArser()) &&
      this.deviceInfo?.browser.name === 'Mobile Safari' &&
      this.deviceInfo.engine.name === 'WebKit';
    console.log('**********isIOsMobilityWebViewUAPArser***********', result);
    return result;
  }

  isWindowAndroidUAPArser() {
    !this.deviceInfo && (this.deviceInfo = this.getDeviceInfo());
    return this.deviceInfo.os.name === 'Windows' || this.deviceInfo.os.name.includes('Android');
  }

  isAppleUAPArser(): boolean {
    !this.deviceInfo && (this.deviceInfo = this.getDeviceInfo());
    return this.deviceInfo.os.name === 'iOS' || this.deviceInfo.os.name === 'Mac OS';
  }

  isIphoneUAPArser() {
    !this.deviceInfo && (this.deviceInfo = this.getDeviceInfo());
    return this.deviceInfo.os.name === 'iOS' && this.deviceInfo.device.type === 'mobile';
  }

  isIpadUAPArser() {
    !this.deviceInfo && (this.deviceInfo = this.getDeviceInfo());
    return (
      (this.deviceInfo.os.name === 'iOS' || this.deviceInfo.os.name === 'Mac OS') &&
      (this.deviceInfo.device.type === 'tablet' || navigator?.maxTouchPoints > 2)
    );
  }

  isSafariUAPArser() {
    return this.isAppleUAPArser() && this.deviceInfo?.browser.name === 'Safari';
  }

  isChromiumNavigator() {
    return (
      !!(navigator as any)['userAgentData'] &&
      (navigator as any)['userAgentData'].brands.some((data: any) => data.brand == 'Chromium')
    );
  }
  // return the last code for the random hex color code.
  charsGenerator() {
    const chars = ['a', 'b', 'c', 'd', 'e', 'f', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const num: number = parseInt((Math.random() * 15).toFixed(0));
    return chars[num];
  }

  // Returns an random hex color code.
  getColor() {
    let coolor = '';
    for (let i = 0; i < 6; i++) {
      coolor = coolor + this.charsGenerator();
    }
    return '#' + coolor;
  }

  // Method that gets the initials from whole participant name.
  getInitials(name: string) {
    let initials = '';
    const arrayNames = name.split(' ');
    const total = arrayNames.length;

    for (let i = 0; i < total; i++) {
      initials += arrayNames[i] && arrayNames[i][0];
    }

    return initials;
  }

  areAvailableMediaDevices(): boolean {
    return 'mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices;
  }

  copyDeepObject(originalObj: any): any {
    const constructedObj = Object.create(originalObj);
    for (const i in originalObj) {
      if (typeof originalObj[i] === 'object') {
        constructedObj[i] = this.deepClone(originalObj[i]);
      } else {
        constructedObj[i] = originalObj[i];
      }
    }
    return constructedObj;
  }

  chunkString(str: string, length: number): Array<string> | null {
    return str.match(new RegExp('.{1,' + length + '}', 'g'));
  }

  openFile(data: string, fileName: string, fileType: string): void {
    const byteCharacters = atob(data.replace(/\s/g, ''));
    const byteNumbers = new Array(byteCharacters.length);
    const newWindowOpenInstance =
      navigator.userAgent.match('Safari/605.1.15') && navigator.userAgent.match('Version/13.1.1');

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: fileType });
    if (window.navigator.msSaveOrOpenBlob) {
      // IE 11+
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else if (navigator.userAgent.match('FxiOS')) {
      // FF iOS
      console.log('Cannot display on FF iOS');
    } else if (navigator.userAgent.match('CriOS')) {
      // Chrome iOS
      const reader = new FileReader();
      reader.onloadend = function () {
        // window.open(reader.result);
      };
      reader.readAsDataURL(blob);
    } else if (newWindowOpenInstance) {
      // Chrome iOS
      const newWindow = window.open('');
      const reader = new FileReader();
      reader.onloadend = function () {
        newWindow.location.href = reader.result as string;
      };
      reader.readAsDataURL(blob);
    } else if (navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i)) {
      // Safari & Opera iOS
      const url = (window.URL || window['webkitURL'] || window || {}).createObjectURL(blob);
      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(url);
      }, 1000);
      // window.location.href = url;
      url && window.open(url, '_blank');
    } else {
      // const url = window.URL.createObjectURL(blob);
      const url = (window.URL || window['webkitURL'] || window || {}).createObjectURL(blob);
      // setTimeout(function () {
      //   // For Firefox it is necessary to delay revoking the ObjectURL
      //   window.URL.revokeObjectURL(url);
      // }, 100);
      url && window.open(url, '_blank');
      // const newWindow = window.open(url, '_blank');
      // newWindow.addEventListener('unload', function (e) {
      //   window.URL.revokeObjectURL(url);
      // });
    }
  }

  downloadFile(url: any, fileName: string): void {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    setTimeout(function () {
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(url);
    }, 1000);
  }

  datatoBlob$(data: string, type: string): Observable<Blob> {
    return new Observable((observer: Observer<Blob>) => {
      const byteString = atob(data);
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const int8Array = new Uint8Array(arrayBuffer);
      for (let i = 0; i < byteString.length; i++) {
        int8Array[i] = byteString.charCodeAt(i);
      }
      const blob = new Blob([int8Array], { type: type });
      observer.next(blob);
      observer.complete();
    });
  }
  datatoBlob(data: string, type: string): Blob {
    const byteString = atob(data);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    return new Blob([int8Array], { type: type });
  }

  blobToUrl(data: Blob, name: string, type: string): SafeUrl {
    const file = new File([data], name, {
      type: type,
    });
    return this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(file));
  }

  readFile(file: any): Observable<FileData> {
    const reader = new FileReader();
    let pattern = this.envConf.data.chat.typesFile.split(',');
    file = file.files[0];
    pattern = pattern.filter((patt: any) => file.type.match(patt));
    const typeFile = pattern[0];
    if (!pattern.length) {
      return throwError('errorType');
    }
    if (file.size > this.envConf.data.chat.maxSizeFile) {
      return throwError('errorSize');
    }
    reader.readAsDataURL(file);

    return new Observable((observer: any) => {
      reader.onload = () => {
        const result: any = (reader.result as any).toString().split(',')[1];
        const fileData = {
          type: typeFile,
          name: file.name,
          chunks: this.chunkString(result, this.envConf.data.chat.chunkFile),
          result: reader.result,
        };
        observer.next(fileData);
        observer.complete();
      };
    });
  }

  private deepClone(oldObj: any): any {
    let newObj;
    // Handle the 3 simple types, and null or undefined
    if (null == oldObj || 'object' !== typeof oldObj) {
      return oldObj;
    }
    // Handle Date
    if (oldObj instanceof Date) {
      newObj = new Date();
      newObj.setTime(oldObj.getTime());
      return newObj;
    }
    // Handle Array
    if (oldObj instanceof Array) {
      newObj = [];
      for (let i = 0; i < oldObj.length; i++) {
        newObj[i] = this.deepClone(oldObj[i]);
      }
      return newObj;
    }
    // Handle Map
    if (oldObj instanceof Map) {
      newObj = new Map(oldObj);
      return newObj;
    }
    // Handle Object
    newObj = Object.create(oldObj);
    for (const attr in oldObj) {
      if (oldObj.hasOwnProperty(attr)) {
        newObj[attr] = this.deepClone(oldObj[attr]);
      } else {
        newObj[attr] = oldObj[attr];
      }
    }
    return newObj;
  }

  getTodayWithHour() {
    const today: Date = new Date();
    return (
      today.getFullYear() +
      ', ' +
      today.getHours() +
      ':' +
      today.getMinutes() +
      ':' +
      today.getSeconds()
    );
  }

  getDeviceInfo(): IUAParserInfo {
    const parser = new UAParser();
    const deviceInfo: IUAParserInfo = parser.getResult() as IUAParserInfo;
    console.log('utils getDeviceInfo ua-parser results:', deviceInfo);
    return deviceInfo;
  }

  getTunningParams(testResults: IResultTest): IPostTunningRequest {
    this.deviceInfo = this.getDeviceInfo();
    const deviceInfoObj = new IPostTunningRequest(this.deviceInfo, testResults);
    return deviceInfoObj;
  }

  getHardwareDevices(ot: any, defaultDevices?: boolean): Observable<any> {
    console.log('AAAAAAAAAAA');
    let devicesList: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    if (!this.defaultDevicesList && !this.devicesList) {
      ot.getDevices(async (error: any, devices: any) => {
        // 🔹 Hacemos la función async
        if (error) {
          console.error('Error obteniendo dispositivos:', error);
          return;
        }

        console.log('utils getHardwareDevices:', devices);

        // Obtener micrófonos y cámaras
        let audioInputDevices = devices.filter((device: any) => device.kind === 'audioInput');
        let videoInputDevices = devices.filter((device: any) => device.kind === 'videoInput');
        
        // Obtener dispositivos de salida de audio con `await`
        let allDevices = await navigator.mediaDevices.enumerateDevices();

        
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: true });

        // Obtiene los video POR DEFECTO
        const videoTrack = stream.getVideoTracks()[0];
        // Lee los deviceId de los tracks activos
        const videoDeviceId = videoTrack.getSettings().deviceId;

        const videoDeviceDefault = allDevices.filter((deviceRef) => {return deviceRef.deviceId === videoDeviceId})[0];


        let audioOutputDevices = allDevices
          .filter((device) => device.kind === 'audiooutput')
          .map((device) => ({
            deviceId: device.deviceId,
            kind: device.kind,
            label: device.label,
            groupId: device.groupId,
          }));

        console.log('Dispositivos de entrada de audio:', audioInputDevices);
        console.log('Dispositivos de video:', videoInputDevices);
        console.log('Dispositivos de salida de audio (parlantes/headsets):', audioOutputDevices);

        // Evitar errores si no hay dispositivos disponibles
        this.defaultDevicesList = {
          audioSource: audioInputDevices[0]?.deviceId || null,
          videoSource: videoInputDevices[0]?.deviceId || null,
          audioOutput: audioOutputDevices[0]?.deviceId || null,
          defaultVideoDevice: videoDeviceDefault?.deviceId || null
        };

        this.devicesList = {
          audioList: audioInputDevices,
          videoList: videoInputDevices,
          audioOutputList: audioOutputDevices,
          defaultVideoDevice: [videoDeviceDefault]
        };

        defaultDevices
          ? devicesList.next(this.defaultDevicesList)
          : devicesList.next(this.devicesList);

        console.log('Lista de dispositivos actualizada:', devicesList.getValue());
      });
    } else {
      defaultDevices
        ? devicesList.next(this.defaultDevicesList)
        : devicesList.next(this.devicesList);
    }
    console.log('Lista de dispositivos:', devicesList.getValue());
    return devicesList.asObservable();
  }

  cleanObject = (obj: any) => {
    for (const propName in obj) {
      if (
        (obj.hasOwnProperty(propName) && obj[propName] === null) ||
        obj[propName] === undefined ||
        obj[propName] === ''
      ) {
        delete obj[propName];
      }
    }

    return obj;
  };

  cleanArray(array: Array<any>): Array<any> {
    const newArray = array.filter((elements) => {
      return elements !== null && elements !== undefined && elements !== '';
    });

    return newArray;
  }
}
